import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Center,
  Flex,
  Heading,
  Image,
  Link,
  Spacer,
  Text,
  VStack,
} from "@chakra-ui/react";
import { EXTERNAL_LINKS } from "../../../utils/constants";
import theVault from "../../../assets/escape_tower/the_vault.jpeg";
import DoubleColumn from "../../molecules/DoubleColumn";
/*
import { AvailableSoon } from "../../molecules";
*/

export default function EscapeTower() {
  return (
    <>
      {/*<AvailableSoon />*/}
      <DoubleColumn>
        <Card px="20px" py="10px">
          <VStack>
            <CardHeader m="auto">
              <Heading size="md">Escape Room</Heading>
            </CardHeader>
            <CardBody>
              <Center>
                <Text mr="16px">
                  <strong>
                    Aperta dal 2 al 24 maggio tutti i Sabato e Domenica e
                    durante Tales nella Rocca degli Alberi.
                    <br />
                    Prenotazioni aperte su{" "}
                    <Link href={EXTERNAL_LINKS.ESCAPE_TALES}>
                      www.escapetales.it
                    </Link>
                  </strong>
                  <br />
                  Età minima 16 anni.
                </Text>
              </Center>
              <Center my={"12px"}>
                <Link href={EXTERNAL_LINKS.ESCAPE_TALES}>
                  <Button>Prenota qui!</Button>
                </Link>
              </Center>
              <Center mb={{ base: 4, md: 0 }}>
                <div className="relative mx-auto rounded-full overflow-hidden">
                  <Image
                    src={theVault}
                    title="Escape Tower nella Rocca degli Alberi - Montagnana (PD)"
                    /*w={{ base: "150px", md: "200px", lg: "250px", xl: "300px" }}*/
                    height="auto"
                    objectFit="contain"
                  />
                </div>
              </Center>
            </CardBody>
          </VStack>
        </Card>
        <Card bg={"#0C0C0A"}>
          <CardHeader>
            <Text
              className="saira"
              fontSize="24px"
              lineHeight="1.6em"
              letterSpacing="0.4px"
              fontWeight="bold"
              color={"#CEF8B0"}
            >
              The Vault 2126
            </Text>
            <Heading size="base" color="white" fontWeight="base">
              Escape Tower nella Rocca degli Alberi - Montagnana (PD)
            </Heading>
          </CardHeader>
          <CardBody>
            <Text
              className="saira"
              fontSize="16px"
              lineHeight="1.6em"
              letterSpacing="0.4px"
              color="white"
            >
              "Un'anomalia improvvisa. Un sistema fuori controllo. Un tempo
              limite che non si ferma. Nel Vault tutto funzionava. Fino ad ora.
              <br />
              <br />
              Il sistema centrale è danneggiato. I protocolli non rispondono
              come dovrebbero. Per ripristinare l’equilibrio servirà intervenire
              manualmente.
              <br />
              <br />
              Se fallite, il reattore collasserà.
              <br />
              E con lui… tutto il Vault.
              <br />
              <br />
              Avete 60 minuti.”
              <br />
              <br />
              Entra nella Rocca degli Alberi e preparati a vivere un’esperienza
              fuori dal tempo.
              <br />
              <br />
              In The Vault 2126 – Escape Tower ti muoverai all’interno della
              torre, alla ricerca di indizi e soluzioni.
              <br />
              <br />
              Avrai solo 60 minuti per tentare di salvare il Vault insieme al
              tuo gruppo.
              <br />
              <br />
              Non è una classica escape room ma un’esperienza immersiva tra
              enigmi, atmosfera e tensione…
              <br />
              <br />
              non sarà solo un gioco.
              <br />
              <br />
              <br />
            </Text>
            {/*<Text
            className="rock-salt-regular"
            fontSize="18px"
            lineHeight="2em"
            letterSpacing="0.4px"
            color="white"
          >
            Tally, il Mago della Rocca
          </Text>
          <Text
            className="rock-salt-regular"
            fontSize="14px"
            lineHeight="2em"
            letterSpacing="0.4px"
            color="white"
          >
            Gran Guardiano del Portale Ogangel
          </Text>*/}
          </CardBody>
        </Card>
      </DoubleColumn>
    </>
  );
}
